/* Angular + external */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
} from "@angular/core";
/***********************/
/* BFX */
// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
// global-services

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { OEAdapterForwardService } from "../services/adapter/oe-adapter-forward.service";
import { ATDLDatasetService } from "../services/atdl/atdl-dataset.service";
import { ATDLUtilityService } from "../services/atdl/atdl-utility.service";
import { ATDLValidatorService } from "../services/atdl/atdl-validator.service";
import { OELoggerService } from "../services/basic/oe-logger.service";
import { OELookupService } from "../services/basic/oe-lookup.service";
import { OEUtilityService } from "../services/basic/oe-utility.service";
import { OEApiService } from "../services/oe-api.service";
// Services
import { OECoordinatorService } from "../services/oe-coordinator.service";
import { OEPanelGammaViewModel } from "../data/models/oe-panel-gamma-view.model";
import { BigNumber } from "shared/cubiq-model-multi-asset";
import { Subscription } from "rxjs";
import { OECommandEventModel } from "../data/models/oe-command-event.model";
import { OENCommand } from "../data/enums/oe-command.enum";
import { OEModelGetterService } from "../services/model/oe-model-getter.service";
import { OEDataModel } from "../data/models/oe-data.model";
import { CcyLookupService, CcyPairLookupService } from "shared/cubiq-services";
import { BfxRequestPriceModel } from "src/app/bfx-interface-controls/models/bfx-interface-controls.models";
import { TranslateService } from "@ngx-translate/core";
import { OEPanelGammaLeg } from "../data/models/oe-panel-gamma-leg.model";
import { OEGammaLegType } from "../data/enums/oe-gamma-leg-type";
import { GammaLegCcyPairTuple } from "../data/models/oe-gamma-leg-pair-tuple.model";
import { NewLegResponse } from "../data/models/oe-panel-gamma-legid-rate.model";
import { runDetached } from "../../../shared/helper-services/run-detached";
import { OEModelSetterService } from "../services/model/oe-model-setter.service";
import { GammaUtils } from "../data/oe-gamma-utilities";
import { OEAdapterGammaHelper } from "../services/adapter/oe-adapter-gamma-helper";
import { OEModelLockingService } from "../services/model/oe-model-locking.service";

@Component({
  selector: "oe-panel-gamma-viewer",
  templateUrl: "./html/oe-panel-gamma-viewer.html",
  standalone: false,
})
export class OEGammaViewerComponent implements OnDestroy, OnInit, OnChanges, AfterViewInit {
  @ViewChildren("gammaLeg", { read: ViewContainerRef }) containerRef: QueryList<ViewContainerRef>;
  @ViewChild("gammaMidLeg", { static: false }) gammaMidLeg: ElementRef;
  @Input() refId: string;
  @Input() rootRefId: string; // refId of the root order

  private _gammaLadderModel: OEPanelGammaViewModel = new OEPanelGammaViewModel();
  private coordinatorSubscription: Subscription;
  private actionPanelSubscription: Subscription;
  private entryPanelSubscription: Subscription;
  private editEnabledByState: boolean;
  private allowCustomise: boolean = true;

  public get gammaLadderModel(): OEPanelGammaViewModel {
    return this._gammaLadderModel;
  }
  public set gammaLadderModel(value: OEPanelGammaViewModel) {
    this._gammaLadderModel = value;
  }

  public config: any = {
    debug: true,
  };

  public data: any = {
    strategyLayoutData: null,
  };

  public control: any = {
    strategyLayout: null,
    scrollbarConfig: {
      suppressScrollX: false, // false is default
      suppressScrollY: false, // false is default
    },
  };

  public style: any = {
    scroll: {
      height: 500,
      maxHeight: 2000,
      minHeight: 400,
      width: 522,
      maxWidth: 522,
      minWidth: 500,
    },
    layoutTarget: {
      height: 480,
      maxHeight: 2000,
      minHeight: 577,
      width: 522,
      maxWidth: 522,
      minWidth: 500,
    },
  };

  public headerData: any = {
    headerDir: {
      label: "HeaderDir",
      label_key: "oe.entry.gamma.viewer.headerDir",
    },
    headerAmt: {
      label: "HeaderAmt",
      label_key: "oe.entry.gamma.viewer.headerAmt",
    },
    headerRate: {
      label: "HeaderRate",
      label_key: "oe.entry.gamma.viewer.headerRate",
    },
    headerDelta: {
      label: "HeaderDelta",
      label_key: "oe.entry.gamma.viewer.headerDelta",
    },
  };
  public dirData: any = {
    buyData: {
      label: "Buy",
      label_key: "oe.entry.gamma.viewer.buy",
    },
    sellData: {
      label: "Sell",
      label_key: "oe.entry.gamma.viewer.sell",
    },
    pipsData: {
      label: "Pips",
      label_key: "oe.entry.gamma.viewer.pips",
    },
  };

  effectiveBase: String;
  effectiveNonBase: String;
  /**********************************************************************/
  /* CONSTRUCTOR  */
  constructor(
    protected translate: TranslateService,
    protected oeLogger: OELoggerService,
    private coordinator: OECoordinatorService,
    private api: OEApiService,
    private forwardAdapter: OEAdapterForwardService,
    private utilityService: OEUtilityService,
    private lookup: OELookupService,
    public renderer2: Renderer2,
    private factoryResolver: ComponentFactoryResolver,
    private atdlDataset: ATDLDatasetService,
    private atdlValidator: ATDLValidatorService,
    private atdlUtility: ATDLUtilityService,
    private orderModelGetterService: OEModelGetterService,
    private currencyService: CcyLookupService,
    private currencyPairService: CcyPairLookupService,
    public cd: ChangeDetectorRef,
    public setter: OEModelSetterService,
    public getter: OEModelGetterService,
    public gammaHelper: OEAdapterGammaHelper,
    private locker: OEModelLockingService,
  ) {
    this.oeLogger = oeLogger.for(__dirname);
    this.initLabelConstr();
  }

  private initLabelConstr(): void {
    this._gammaLadderModel.dirHeaderLabel = this.translate.instant(
      this.headerData.headerDir.label_key,
    );
    this._gammaLadderModel.amountHeaderLabel = this.translate.instant(
      this.headerData.headerAmt.label_key,
    );
    this._gammaLadderModel.rateHeaderLabel = this.translate.instant(
      this.headerData.headerRate.label_key,
    );
    this._gammaLadderModel.deltaHeaderLabel = this.translate.instant(
      this.headerData.headerDelta.label_key,
    );
    this._gammaLadderModel.buyLabel = this.translate.instant(this.dirData.buyData.label_key);
    this._gammaLadderModel.sellLabel = this.translate.instant(this.dirData.sellData.label_key);
    this._gammaLadderModel.pipsLabel = this.translate.instant(this.dirData.pipsData.label_key);
  }

  /**********************************************************************/
  /* GAMMA ENTRY API */
  public isReady(): boolean {
    return true;
  }

  public resizeGammaViewer(height: number) {
    if (this.gammaLadderModel.hasError) {
      this.style.scroll.height = height - 122;
    } else {
      this.style.scroll.height = height - 60;
    }
  }

  private reloadFromMaster(duplicate: boolean = false): void {
    let model: OEDataModel = this.orderModelGetterService.get(this.refId);

    if (model.gammaModel != null) {
      this.gammaLadderModel = model.gammaModel;
      if (
        this.gammaLadderModel != null &&
        this.gammaLadderModel.customizeMode != null &&
        this.editEnabledByState === true
      ) {
        this.allowCustomise = this.gammaLadderModel.customizeMode;
        this.gammaLadderModel.edit = this.allowCustomise;
      }
    } else {
      model.gammaModel = this.gammaLadderModel;
    }

    if (this.gammaLadderModel.buyLabel == null) {
      this.initLabelConstr();
    }

    // Bail if we are in customize mode
    if (this._gammaLadderModel.customizeMode === true) {
      return;
    }

    if (model.ccyPairModel != null) {
      this.createCcyPairModel(model.ccyPairModel, model.ccyPair);
      this.coordinator.sendCcyPairToViewer(this.refId, this.gammaLadderModel.currencyPair);
    }

    if (model.fixedCcy) {
      let fixed: CubiqTS.CurrencyImpl = this.currencyService.getCcy(model.fixedCcy.ccy);
      this.changeFixedCcy(fixed);
    }

    //in liue of aps changes
    if (model.delta != null) {
      let delta = new BigNumber(model.delta);
      this.changeDelta(delta);
    }

    if (model.orderAmount != null) {
      this.changeOrderAmount(new BigNumber(model.orderAmount));
    }

    if (model.requestPrice != null) {
      this.changeRate(model.requestPrice);
    }

    if (model.orderType != null) {
      let orderType: CubiqTS.OrderType =
        model.orderType.value == 0 ? CubiqTS.OrderType.LIMIT_TP : CubiqTS.OrderType.LIMIT_SL;
      this.changeOrderType(orderType);
    }

    // If reloading master from duplicate call rungs are already on master model
    if (duplicate === true) {
      this.gammaLadderModel.gammaLegsAbove = model.gammaModel.gammaLegsAbove;
      this.gammaLadderModel.gammaLegsBelow = model.gammaModel.gammaLegsBelow;
    } else {
      if (model.rungsAbove >= 0) {
        this.changeRungsAbove(model.rungsAbove);
      }

      if (model.rungsBelow >= 0) {
        this.changeRungsBelow(model.rungsBelow);
      }
    }

    this.checkAndRegenerateGammaLegs();
  }

  private isGammaModelPopulated(): boolean {
    if (this.gammaLadderModel == null) {
      return false;
    }
    if (this.gammaLadderModel.currencyPair == null) {
      return false;
    }
    if (this.gammaLadderModel.fixedCcy == null) {
      return false;
    }
    if (this.gammaLadderModel.amount == null) {
      return false;
    }
    if (this.gammaLadderModel.midRate == null) {
      return false;
    }
    if (this.gammaLadderModel.rungsAbove == null && this.gammaLadderModel.rungsBelow == null) {
      return false;
    }
    if (this.gammaLadderModel.orderType == null) {
      return false;
    }
    if (this.gammaLadderModel.delta == null) {
      return false;
    }

    return true;
  }

  private changeOrderType(value: CubiqTS.OrderType): void {
    this._gammaLadderModel.orderType = value;
  }

  private changeRungsAbove(value: number): void {
    this._gammaLadderModel.rungsAbove = value;
  }

  private changeRungsBelow(value: number): void {
    this._gammaLadderModel.rungsBelow = value;
  }

  private changeDelta(value: BigNumber): void {
    this._gammaLadderModel.delta = value;
  }

  private changeFixedCcy(value: CubiqTS.Currency): void {
    this._gammaLadderModel.fixedCcy.fixedCcy = value.id;
  }

  private changeOrderAmount(value: BigNumber): void {
    this._gammaLadderModel.amount = value;
  }

  private changeRate(value: BigNumber): void {
    this._gammaLadderModel.midRate[0] = new BfxRequestPriceModel();
    this._gammaLadderModel.midRate[0].value = value;
    this._gammaLadderModel.gammaMedLeg = new OEPanelGammaLeg();
    this._gammaLadderModel.gammaMedLeg.rate = value;

    let entryDecs: number = GammaUtils.getPairEntryPrecision(
      this._gammaLadderModel.currencyPair.model,
      this._gammaLadderModel.currencyPair.inverted,
    );
    this._gammaLadderModel.midRate[0].textValue =
      this._gammaLadderModel.midRate[0].value.toFixed(entryDecs);
  }

  private checkAndRegenerateGammaLegs(): void {
    if (this.isGammaModelPopulated()) {
      this._gammaLadderModel.regenerateGammaLegModel();
      //create min max rate model;
      //this._gammaLadderModel.applyMinMaxRates();

      if (this._gammaLadderModel.hasError === true) {
        this.coordinator.cmdUpdateGammaIneligibilty(this.refId);
        setTimeout(() => {
          this.coordinator.disableGammaCustomiseButton(this.refId);
        }, 100);
      }
      if (this._gammaLadderModel.hasError === false) {
        this.coordinator.cmdUpdateGammaEligibilty(this.refId);

        setTimeout(() => {
          //??
          this.coordinator.enabledGammaCustomiseButton(this.refId);
        }, 100);
      }
    } else if (this.gammaLadderModel.edit === false) {
      setTimeout(() => {
        this.coordinator.disableGammaCustomiseButton(this.refId);
      }, 100);
    }
  }

  /**********************************************************************/
  /* LIFE CYCLE HOOKS */

  ngOnInit() {
    this.getWindowHeight();
  }

  ngOnDestroy() {
    let subscriptions: Subscription[] = [
      this.actionPanelSubscription,
      this.coordinatorSubscription,
      this.entryPanelSubscription,
    ];

    subscriptions
      .filter((s) => s != null)
      .forEach((s) => {
        try {
          s.unsubscribe();
        } catch (e) {
          logger.out.warn(`${this.constructor.name}: Failed to close subscription {${e}}`);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {}

  ngAfterViewInit() {
    // this.setter.setGammaModel(this.refId, this.gammaLadderModel);
    this.initialize();
  }

  /**
   * Works on browser. On desktop gets triggered on main window resize, but has no effect, so all good.
   * Could be refactored for improved performance on desktop, but it will be negligible improvement.
   */
  @HostListener("window:resize", ["$event"])
  getWindowHeight(event?): void {}

  /**********************************************************************/
  /* INITIALIZATION */

  public initialize(): void {
    this.subscribeToCoordinator();
    this.subscribeToNotificationsCoordinator();
    this.subscribeToEntry();
  }

  private reInitialize(): void {}

  private subscribeToEntry(): void {
    this.entryPanelSubscription = this.coordinator.entryPanelCmd$
      .pipe(runDetached(this))
      .subscribe(($event: OECommandEventModel) => {
        if ($event.ref === this.refId && $event.cmd === OENCommand.LOAD_CONTROLS) {
          if (
            this.gammaLadderModel != null &&
            this.gammaLadderModel.customizeMode != null &&
            this.editEnabledByState === true
          ) {
            this.allowCustomise = this.gammaLadderModel.customizeMode;
            this.gammaLadderModel.edit = this.allowCustomise;

            if (this.gammaLadderModel.customizeMode) {
              let gammaLockProfile = this.locker.createLockForCustomiseGamma(this.refId);
              this.coordinator.cmdLoadInterfaceControlLockingProfile(this.refId, gammaLockProfile);
            }
          }
        }
      });
  }

  /**********************************************************************/
  /* COORDINATOR HANDLER */
  private subscribeToCoordinator(): void {
    this.coordinatorSubscription = this.coordinator.strategyPanelCmd$
      .pipe(runDetached(this))
      .subscribe(($event: OECommandEventModel) => {
        if ($event.ref === this.refId) {
          switch ($event.cmd) {
            case OENCommand.GAMMA_DUPLICATE_LOAD:
              this.reloadFromMaster(true);

              if (this.gammaLadderModel.customizeMode == null) {
                this.gammaLadderModel.customizeMode = true;
              }

              this.allowCustomise = this.gammaLadderModel.customizeMode;
              this.gammaLadderModel.edit = this.gammaLadderModel.customizeMode;
              console.error(`MODE: ${this._gammaLadderModel.customizeMode}`);

              if (this.gammaLadderModel.customizeMode) {
                let gammaLockProfile = this.locker.createLockForCustomiseGamma(this.refId);
                this.coordinator.cmdLoadInterfaceControlLockingProfile(
                  this.refId,
                  gammaLockProfile,
                );
              }

              this.recalculateDeltasAbove(this.gammaLadderModel.gammaLegsAbove);
              this.recalculateDeltasBelow(this.gammaLadderModel.gammaLegsBelow);

              GammaUtils.calculateRateBoundaries(this.gammaLadderModel);
              this.topLegToCustomise();

              setTimeout(() => {
                this.coordinator.enabledGammaCustomiseButton(this.refId);
              }, 100);
              break;
            case OENCommand.PANEL_UPDATE_STRATEGY:
              this.reloadFromMaster();
              break;
            case OENCommand.GAMMA_CUSTOMISE:
              this._gammaLadderModel.customizeMode = true;
              this.allowCustomise = true;
              this.gammaLadderModel.edit = this.allowCustomise && this.editEnabledByState;
              if (this.isGammaModelPopulated) {
                GammaUtils.calculateRateBoundaries(this.gammaLadderModel);
                this.topLegToCustomise();
              }
              break;
            case OENCommand.SAVE_GAMMA_TO_MODEL:
              let currentData: OEDataModel = null;
              currentData = this.getter.get(this.refId);
              currentData.gammaModel = this.gammaLadderModel;
              break;
            case OENCommand.GAMMA_RESTORE:
              this._gammaLadderModel.customizeMode = false;
              this.gammaLadderModel.edit = false;
              this.allowCustomise = false;
              break;
            case OENCommand.UPDATE_GAMMA_ELIGIBLE:
              break;
            case OENCommand.UPDATE_GAMMA_INELIGIBLE:
              break;
            case OENCommand.GAMMA_DISABLE_CUST_BUTTON:
              break;
            case OENCommand.GAMMA_ENABLE_CUST_BUTTON:
              break;
            case OENCommand.GAMMA_TOP_LEG:
              break;
            case OENCommand.GAMMA_NEW_LEG_RESP:
              break;
            case OENCommand.GAMMA_CUSTOM_RATE_CHANGE:
              break;
            case OENCommand.GAMMA_CUST_CCYPAIR_UPDATE:
              break;
            case OENCommand.RESET_ALL:
              this.gammaLadderModel = new OEPanelGammaViewModel();
              this.initLabelConstr();
              break;
            default:
              logger.out.error(
                `ERROR: oeGammaViewer.subscribeToCoordinator(): Command not implemented! command= (${
                  $event.cmd
                }) [${$event.cmd != null ? OENCommand[$event.cmd] : "NULL"}]`,
              );
              break;
            case OENCommand.GAMMA_UPDATED_CUST_LEG:
              logger.out.info($event.data);
              let newLeg: OEPanelGammaLeg = $event.data;
              this.insertNewLeg(newLeg);
              break;
          }
        }
      });
  }

  /*
  Need to listen to commands from the button/action panel on the entry form so we can disable/enable customisation 
  on gamma viwer component on submit*/
  private subscribeToNotificationsCoordinator(): void {
    this.actionPanelSubscription = this.coordinator.notificationsPanelCmd$
      .pipe(runDetached(this))
      .subscribe(($event: OECommandEventModel) => {
        if ($event.ref === this.refId || $event.ref === this.rootRefId) {
          this.oeLogger.outputDevLogToConsole(
            `DEV: NotificationsPanel -> UPDATE: ${OENCommand[$event.cmd]} | Event: `,
            false,
            $event,
          );

          switch ($event.cmd) {
            case OENCommand.STATE_ORDER_PROCESSING:
              this.editEnabledByState = false;
              this.gammaLadderModel.edit = this.editEnabledByState;
              break;
            case OENCommand.STATE_ORDER_ENTRY:
              this.editEnabledByState = true;
              break;
          }
        }
      });
  }

  /*send the top leg to the customise component, top leg of the above array, or the mid.
   */
  private topLegToCustomise(): void {
    let topLeg: OEPanelGammaLeg = null;
    let tuple: GammaLegCcyPairTuple = new GammaLegCcyPairTuple();
    tuple.ccyPair = this.gammaLadderModel.currencyPair;

    if (
      this.gammaLadderModel.gammaLegsAbove != null &&
      this.gammaLadderModel.gammaLegsAbove.length > 0
    ) {
      topLeg = this.gammaLadderModel.gammaLegsAbove[0].cloneGammaLeg();
      tuple.leg = topLeg;
    } else {
      tuple.leg = this.gammaLadderModel.gammaMedLeg;
    }

    //if there is no above legs, we should use mid rate as next in line.
    //it has no amount so use what entry spinner has.
    if (tuple.leg.amount == null) {
      tuple.leg.amount = this.gammaLadderModel.amount;
    }
    this.coordinator.sendTopGammaLeg(this.refId, tuple);
  }

  /*
  new leg being inserted above midRate. verify for close to neighbours
  recalcualte the deltas for pip delta display
  */
  private handleRateAboveMidpoint(newLeg: OEPanelGammaLeg): void {
    let aboveLeg: OEPanelGammaLeg = null;
    let belowLeg: OEPanelGammaLeg = null;
    let indexOfNewLeg: number = null;
    if (
      this.gammaLadderModel.gammaLegsAbove == null ||
      this.gammaLadderModel.gammaLegsAbove.length == 0
    ) {
      indexOfNewLeg = 0;
    } else {
      indexOfNewLeg = GammaUtils.searchAbove(this.gammaLadderModel.gammaLegsAbove, newLeg.rate);
    }

    if (indexOfNewLeg > -1) {
      if (indexOfNewLeg == 0) {
        belowLeg = this.gammaLadderModel.gammaLegsAbove[0];
        aboveLeg = null;
      }
      if (indexOfNewLeg > this.gammaLadderModel.gammaLegsAbove.length - 1) {
        belowLeg = null;
        aboveLeg =
          this.gammaLadderModel.gammaLegsAbove[this.gammaLadderModel.gammaLegsAbove.length - 1];
      } else if (indexOfNewLeg > 0 && indexOfNewLeg < this.gammaLadderModel.gammaLegsAbove.length) {
        belowLeg = this.gammaLadderModel.gammaLegsAbove[indexOfNewLeg];
        aboveLeg = this.gammaLadderModel.gammaLegsAbove[indexOfNewLeg - 1];
      }
    }

    if (belowLeg == null) {
      belowLeg = new OEPanelGammaLeg();
      belowLeg.rate = this.gammaLadderModel.midRate[0].value;
    }

    let minPips: CubiqTS.Long = this.gammaLadderModel.currencyPair.model.minimumGammaDeltaPips;
    if (minPips == null) {
      minPips = new CubiqTS.Long(10);
    }
    let istooCloseAbove: boolean = this.evalNewLegAbove(
      newLeg,
      aboveLeg,
      false,
      new BigNumber(minPips.toString()),
    );
    let istooCloseBelow: boolean = this.evalNewLegBelow(
      newLeg,
      belowLeg,
      false,
      new BigNumber(minPips.toString()),
    );

    if (istooCloseAbove == false && istooCloseBelow == false && indexOfNewLeg != -1) {
      this.gammaLadderModel.gammaLegsAbove.push(newLeg);
      this.gammaLadderModel.sort(true);

      //recalculate deltas.
      if (indexOfNewLeg > -1) {
        this.rebuildLegIdsAboveAddition();
      }

      this.recalculateDeltasAbove(this.gammaLadderModel.gammaLegsAbove);
    } else {
      let response: NewLegResponse = new NewLegResponse();
      response.isTooCloseAbove = istooCloseAbove;
      response.isTooCloseBelow = istooCloseBelow;
      response.legType = OEGammaLegType.ABOVE;
      logger.out.info("Leg is invalid " + newLeg.rate);
      this.coordinator.sendNewLegResponse(this.refId);
    }
  }

  /*new leg being inserted below midRate. verify for close to neighbours.
  recalcualte the deltas for pip delta display
  */
  private handleRateBelowMidpoint(newLeg: OEPanelGammaLeg): void {
    let aboveLeg: OEPanelGammaLeg = null;
    let belowLeg: OEPanelGammaLeg = null;
    let indexOfNewLeg: number = null;
    if (
      this.gammaLadderModel.gammaLegsBelow == null ||
      this.gammaLadderModel.gammaLegsBelow.length == 0
    ) {
      indexOfNewLeg = 0;
    } else {
      indexOfNewLeg = GammaUtils.searchBelow(this.gammaLadderModel.gammaLegsBelow, newLeg.rate);
    }

    if (indexOfNewLeg != -1) {
      if (indexOfNewLeg == 0) {
        belowLeg = this.gammaLadderModel.gammaLegsBelow[0];
        aboveLeg = null;
      }
      if (indexOfNewLeg > this.gammaLadderModel.gammaLegsBelow.length - 1) {
        belowLeg = null;
        aboveLeg =
          this.gammaLadderModel.gammaLegsBelow[this.gammaLadderModel.gammaLegsBelow.length - 1];
      } else if (indexOfNewLeg > 0 && indexOfNewLeg < this.gammaLadderModel.gammaLegsBelow.length) {
        aboveLeg = this.gammaLadderModel.gammaLegsBelow[indexOfNewLeg - 1]; //??jm
        belowLeg = this.gammaLadderModel.gammaLegsBelow[indexOfNewLeg + 1];
      }
    }

    if (aboveLeg == null) {
      aboveLeg = new OEPanelGammaLeg();
      aboveLeg.rate = this.gammaLadderModel.midRate[0].value;
    }

    let minPips: CubiqTS.Long = this.gammaLadderModel.currencyPair.model.minimumGammaDeltaPips;
    if (minPips == null) {
      minPips = new CubiqTS.Long(10);
    }
    let istooCloseAbove: boolean = this.evalNewLegAbove(
      newLeg,
      aboveLeg,
      true,
      new BigNumber(minPips.toString()),
    );
    let istooCloseBelow: boolean = this.evalNewLegBelow(
      newLeg,
      belowLeg,
      true,
      new BigNumber(minPips.toString()),
    );

    if (istooCloseAbove == false && istooCloseBelow == false && indexOfNewLeg != -1) {
      this.gammaLadderModel.gammaLegsBelow.push(newLeg);
      this.gammaLadderModel.sort(false);
      //recalculate deltas.
      if (indexOfNewLeg < this.gammaLadderModel.gammaLegsBelow.length) {
        this.rebuildLegIdsBelowAddition();
      }
      this.recalculateDeltasBelow(this.gammaLadderModel.gammaLegsBelow);
    } else {
      let response: NewLegResponse = new NewLegResponse();
      response.isTooCloseAbove = istooCloseAbove;
      response.isTooCloseBelow = istooCloseBelow;
      response.legType = OEGammaLegType.BELOW;
      logger.out.info("Leg is invalid " + newLeg.rate);
      this.coordinator.sendNewLegResponse(this.refId);
    }
  }

  private recalculateDeltasAbove(array: OEPanelGammaLeg[]): void {
    let map = new Map(); //pos =0,1,2,3,4
    array.forEach(function (value) {
      //id = 5,4,3,2,1
      map.set(value.legId, value);
    });

    array.forEach((element, index) => {
      let aboveLeg: OEPanelGammaLeg = null;
      let belowLeg: OEPanelGammaLeg = null;

      if (map.has(element.legId + 1)) {
        aboveLeg = map.get(element.legId + 1); // map 6? no no above = correct.
      }
      if (map.has(element.legId - 1)) {
        belowLeg = map.get(element.legId - 1);
      }

      this._gammaLadderModel.recalulateDeltaAbove(
        element,
        aboveLeg,
        belowLeg,
        this.gammaLadderModel.midRate[0].value,
      );
    });
  }

  private recalculateDeltasBelow(array: OEPanelGammaLeg[]): void {
    let map = new Map();
    array.forEach(function (value) {
      map.set(value.legId, value);
    });

    array.forEach((element, index) => {
      let lowerLeg: OEPanelGammaLeg = null;
      let higherLeg: OEPanelGammaLeg = null;

      if (map.has(element.legId + 1)) {
        higherLeg = map.get(element.legId + 1);
      }
      if (map.has(element.legId - 1)) {
        lowerLeg = map.get(element.legId - 1);
      }

      this._gammaLadderModel.recalulateDeltaBelow(
        element,
        higherLeg,
        lowerLeg,
        this.gammaLadderModel.midRate[0].value,
      );
    });
  }

  /*
  ensure the new custom leg doesnt collide with existing leg.
  */
  private checkForDuplicateRate(newLeg: OEPanelGammaLeg): boolean {
    let aboveMap = new Map();
    let belowMap = new Map();
    if (newLeg.rate == this.gammaLadderModel.midRate[0].value) {
      logger.out.info("leg is duplicate of MidRate");
      return true;
    }
    if (
      this.gammaLadderModel.gammaLegsAbove != null &&
      this.gammaLadderModel.gammaLegsAbove.length > 0
    ) {
      this.gammaLadderModel.gammaLegsAbove.forEach(function (value) {
        aboveMap.set(value.rate.toNumber(), value);
      });
      if (aboveMap.get(newLeg.rate.toNumber())) {
        return true;
      }
    }
    if (
      this.gammaLadderModel.gammaLegsBelow != null &&
      this.gammaLadderModel.gammaLegsBelow.length > 0
    ) {
      this.gammaLadderModel.gammaLegsBelow.forEach(function (value) {
        belowMap.set(value.rate.toNumber(), value);
      });
      if (belowMap.get(newLeg.rate.toNumber())) {
        return true;
      }
    }

    return false;
  }

  //called from customise component
  private insertNewLeg(newLeg: OEPanelGammaLeg): void {
    //same as mid
    if (newLeg.rate.toNumber() == this._gammaLadderModel.midRate[0].value.toNumber()) {
      this.coordinator.sendNewLegResponse(this.refId);
      return;
    }

    //has same rate
    let hasDupes: boolean = this.checkForDuplicateRate(newLeg);

    if (hasDupes) {
      logger.out.info("Leg is duplicate " + newLeg.rate);
      this.coordinator.sendNewLegResponse(this.refId);
      return;
    }

    if (newLeg.rate.toNumber() > this._gammaLadderModel.midRate[0].value.toNumber()) {
      newLeg.direction = this.gammaLadderModel.getDirection(true);
      newLeg.legType = OEGammaLegType.ABOVE;
      this.handleRateAboveMidpoint(newLeg);
    } else {
      newLeg.direction = this.gammaLadderModel.getDirection(false);
      newLeg.legType = OEGammaLegType.BELOW;
      this.handleRateBelowMidpoint(newLeg);
    }
    GammaUtils.calculateRateBoundaries(this.gammaLadderModel);
  }

  //from the deletion button on each leg.
  public removeLeg(data: any): void {
    if (!this.gammaLadderModel.edit) {
      return;
    }
    if (data.legType == OEGammaLegType.ABOVE) {
      GammaUtils.removeFromArray(this.gammaLadderModel.gammaLegsAbove, data);
      this.rebuildLegIdsAboveDeletion();
      this.recalculateDeltasAbove(this.gammaLadderModel.gammaLegsAbove);
    } else if (data.legType == OEGammaLegType.BELOW) {
      GammaUtils.removeFromArray(this.gammaLadderModel.gammaLegsBelow, data);
      this.rebuildLegIdsBelowDeletion();
      this.recalculateDeltasBelow(this.gammaLadderModel.gammaLegsBelow);
    } else {
      //noop
    }
    GammaUtils.calculateRateBoundaries(this._gammaLadderModel);
  }

  /*Is too close to leg above.called by custom leg insert to check is valid addition*/
  public evalNewLegAbove(
    newLeg: OEPanelGammaLeg,
    aboveLeg: OEPanelGammaLeg,
    isBelowMidRate: boolean,
    minDelta: BigNumber,
  ): boolean {
    let minDeltaIncrement: BigNumber = GammaUtils.getPipsIncrementPart(
      this.gammaLadderModel.currencyPair.model,
      this.gammaLadderModel.currencyPair.inverted,
      minDelta,
    );
    if (aboveLeg == null) {
      return false;
    }

    let delta: CubiqTS.BigNumber = aboveLeg.rate.minus(newLeg.rate);
    delta.toString();
    if (delta.absoluteValue().toNumber() >= minDeltaIncrement.absoluteValue().toNumber()) {
      //delta 0.0003  minDeltaIncrement 0.0002
      return false;
    }
    return true;
  }

  /*Is too close to leg below. called by custom leg insert to check is valid addition*/
  public evalNewLegBelow(
    newLeg: OEPanelGammaLeg,
    belowLeg: OEPanelGammaLeg,
    isBelowMidRate: boolean,
    minDelta: BigNumber,
  ): boolean {
    let minDeltaIncrement: BigNumber = GammaUtils.getPipsIncrementPart(
      this.gammaLadderModel.currencyPair.model,
      this.gammaLadderModel.currencyPair.inverted,
      minDelta,
    );
    if (belowLeg == null) {
      return false;
    }
    let delta: CubiqTS.BigNumber = newLeg.rate.minus(belowLeg.rate);
    if (delta.absoluteValue().toNumber() >= minDeltaIncrement.absoluteValue().toNumber()) {
      //delta 0.0003  minDeltaIncrement 0.0002
      return false;
    }
    return true;
  }

  //rate field on leg change.
  public handleSpinnerChange(leg: OEPanelGammaLeg): void {
    if (!this.gammaLadderModel.edit || leg == null) {
      return;
    }
    if (leg.legType == OEGammaLegType.ABOVE) {
      this.recalculateDeltasAbove(this._gammaLadderModel.gammaLegsAbove);
    } else {
      this.recalculateDeltasBelow(this._gammaLadderModel.gammaLegsBelow);
    }
    GammaUtils.calculateRateBoundaries(this.gammaLadderModel);
    this.coordinator.sendLegCustomRateChange(this.refId);
  }
  //the mid rate spinner changes. rebuild all rates off the mid rate and existing deltas
  public handleMidSpinnerChange(leg: OEPanelGammaLeg) {
    if (this.gammaLadderModel.edit) {
      this.recalculateRatesAboveMid();
      this.gammaLadderModel.sort(true);
      this.recalculateRatesBelowMid();
      this.coordinator.sendLegCustomRateChange(this.refId);
    }
  }

  //r = m
  //d = d@p1
  //newR = r+d
  private recalculateRatesAboveMid(): void {
    if (!GammaUtils.assertNotNullEmpty(this._gammaLadderModel.gammaLegsAbove)) {
      return;
    }

    //old navajo trick. cloning the array means the model changes between the
    //leg rate spiiner event and the midrate event dont get cross fired
    let cloneArray: Array<OEPanelGammaLeg> = [];
    this.gammaLadderModel.gammaLegsAbove.forEach((element) => {
      cloneArray.push(element.cloneGammaLeg());
    });

    cloneArray.sort(function (a, b) {
      if (a.rate > b.rate) return -1;
      if (a.rate < b.rate) return 1;
      return 0;
    });
    cloneArray.sort();

    let i: number = cloneArray.length - 1;
    let firstLegRate: BigNumber = null;
    let nextLeg: OEPanelGammaLeg = null;
    for (i; i >= 0; i--) {
      if (i == cloneArray.length - 1) {
        firstLegRate = this.gammaLadderModel.midRate[0].value;
      } else {
        firstLegRate = cloneArray[i + 1].rate;
      }
      nextLeg = cloneArray[i];
      let pipsPart: BigNumber = GammaUtils.getPipsIncrementPart(
        this.gammaLadderModel.currencyPair.model,
        this.gammaLadderModel.currencyPair.inverted,
        nextLeg.delta,
      );
      let newRate: BigNumber = firstLegRate.plus(pipsPart);
      nextLeg.rate = newRate;

      // this.gammaLadderModel.gammaLegsAbove = cloneArray;
    }
    this.gammaLadderModel.gammaLegsAbove = cloneArray;
  }

  //r = m
  //d = d@p1
  //newR = r+d
  private recalculateRatesBelowMid(): void {
    if (!GammaUtils.assertNotNullEmpty(this._gammaLadderModel.gammaLegsBelow)) {
      return;
    }

    //old navajo trick.cloning the array means the model changes between the
    //leg rate spinner event and the midrate event dont get cross fired
    let cloneArray: Array<OEPanelGammaLeg> = [];
    this.gammaLadderModel.gammaLegsBelow.forEach((element) => {
      cloneArray.push(element.cloneGammaLeg());
    });

    let i: number = 0;
    let firstLegRate: BigNumber = null;
    let nextLeg: OEPanelGammaLeg = null;
    for (i; i <= cloneArray.length - 1; i++) {
      if (i == 0) {
        firstLegRate = this.gammaLadderModel.midRate[0].value;
      } else {
        firstLegRate = cloneArray[i - 1].rate;
      }
      nextLeg = cloneArray[i];
      nextLeg.rate.toString();
      let pipsPart: BigNumber = GammaUtils.getPipsIncrementPart(
        this.gammaLadderModel.currencyPair.model,
        this.gammaLadderModel.currencyPair.inverted,
        nextLeg.delta,
      );
      let newRate: BigNumber = firstLegRate.minus(pipsPart);
      nextLeg.rate = newRate;
    }

    this.gammaLadderModel.gammaLegsBelow = cloneArray;
  }

  private createCcyPairModel(model: CubiqTS.CurrencyPairImpl, effective: string): void {
    let effectivePair: string = effective;
    this.effectiveBase = effectivePair.substring(0, 3);
    this.effectiveNonBase = effectivePair.substring(3, 6);
    let inverted: boolean = this.effectiveBase != model.base;
    this.gammaLadderModel.currencyPair.model = model;
    this.gammaLadderModel.currencyPair.inverted = inverted;
    this.gammaLadderModel.currencyPair.base = model.base;
    this.gammaLadderModel.currencyPair.nonBase = model.nonBase;
    this.gammaLadderModel.currencyPair.product = effective;
    this.gammaLadderModel.effectiveBase = this.effectiveBase;
    this.gammaLadderModel.effectiveNonBase = this.effectiveNonBase;
    // Check if there is an invert available
    if (this.gammaLadderModel.currencyPair.model) {
      this.gammaLadderModel.currencyPair.spotEnabled =
        this.gammaLadderModel.currencyPair.model.spotEnabledFg;
      this.gammaLadderModel.currencyPair.fwdEnabled =
        this.gammaLadderModel.currencyPair.model.allowFwdFwdTriggerFg ||
        this.gammaLadderModel.currencyPair.model.allowFwdSpotTriggerFg;
      this.gammaLadderModel.currencyPair.ndfEnabled =
        this.gammaLadderModel.currencyPair.model.allowNdfFwdTriggerFg ||
        this.gammaLadderModel.currencyPair.model.allowNdfSpotTriggerFg;
      this.gammaLadderModel.currencyPair.mktEnabled =
        this.gammaLadderModel.currencyPair.model.allowMarketOrdersFg;
    } else {
      this.gammaLadderModel.currencyPair.spotEnabled = false;
      this.gammaLadderModel.currencyPair.fwdEnabled = false;
      this.gammaLadderModel.currencyPair.ndfEnabled = false;
      this.gammaLadderModel.currencyPair.mktEnabled = false;
    }
  }

  private rebuildLegIdsAboveAddition() {
    let i: number = this.gammaLadderModel.gammaLegsAbove.length - 1;
    let legId: number = 1;
    for (i; i >= 0; i--) {
      let nextLeg: OEPanelGammaLeg = this.gammaLadderModel.gammaLegsAbove[i];
      nextLeg.legId = legId;
      legId++;
    }
  }

  private rebuildLegIdsBelowAddition() {
    let i: number = 0;
    let legId: number = 1;
    for (i; i < this.gammaLadderModel.gammaLegsBelow.length; i++) {
      let nextLeg: OEPanelGammaLeg = this.gammaLadderModel.gammaLegsBelow[i];
      nextLeg.legId = legId * -1;
      legId++;
    }
  }

  private rebuildLegIdsAboveDeletion() {
    let count: number = this._gammaLadderModel.gammaLegsAbove.length - 1;
    let legId: number = 1;
    for (count = count; count >= 0; count--) {
      this._gammaLadderModel.gammaLegsAbove[count].legId = legId;
      legId++;
    }
  }

  private rebuildLegIdsBelowDeletion() {
    let count: number = 1;
    this.gammaLadderModel.gammaLegsBelow.forEach((element) => {
      element.legId = count * -1;
      count++;
    });
  }
}
